import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { Badge } from "@/lib/ui";
import { Wallet } from "lucide-react";

const color = { pending: "gold", paid: "green", disputed: "red", waived: "slate" };

export default function AdminPayments() {
  const [filter, setFilter] = useState("disputed");
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState("");
  const load = () => api.get("/admin/expenses", { params: { status: filter } }).then((r) => setItems(r.data));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const resolve = async (id, decision) => {
    setBusy(id);
    try { await api.post(`/admin/expenses/${id}/resolve`, { decision, note: decision === "approve" ? "Approved by Kindred support" : "Waived after review" }); toast.success(decision === "approve" ? "Reimbursed helper" : "Expense waived"); load(); }
    catch (err) { toast.error(formatError(err.response?.data?.detail)); }
    finally { setBusy(""); }
  };

  return (
    <div>
      <div className="flex gap-2 mb-4">
        {["disputed", "pending", "paid", "waived", "all"].map((s) => (
          <button key={s} data-testid={`expense-filter-${s}`} onClick={() => setFilter(s)}
            className={`px-4 min-h-[44px] rounded-xl font-semibold capitalize transition-all ${filter === s ? "bg-[#2E7D6B] text-white" : "bg-white border border-[#E2D9CE] text-slate-700"}`}>{s}</button>
        ))}
      </div>
      <div className="bg-white border border-[#E2D9CE] rounded-2xl divide-y divide-[#E2D9CE]">
        {items.length === 0 ? <p data-testid="expenses-empty" className="p-6 text-slate-600">No {filter === "all" ? "" : filter} expenses.</p> : items.map((e) => (
          <div key={e.request_id} data-testid={`expense-item-${e.request_id}`} className="p-5 flex flex-wrap items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <span className="w-12 h-12 rounded-full bg-[#FBEBE4] flex items-center justify-center"><Wallet className="w-6 h-6 text-[#D96B43]" /></span>
              <div>
                <Link to={`/requests/${e.request_id}`} className="font-semibold text-slate-900 hover:text-[#D96B43]">{e.title}</Link>
                <p className="text-slate-600 text-sm">₹{Number(e.amount).toFixed(2)} · helper {e.helper_name} · seeker {e.seeker_name} · {e.receipts_count} receipt(s)</p>
                {e.reimbursement?.note && <p className="text-sm text-red-700 mt-1">Dispute: “{e.reimbursement.note}”</p>}
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Badge color={color[e.reimbursement.status] || "slate"}>{e.reimbursement.status}</Badge>
              {["pending", "disputed"].includes(e.reimbursement.status) && (
                <>
                  <button data-testid={`expense-approve-${e.request_id}`} disabled={busy === e.request_id} onClick={() => resolve(e.request_id, "approve")} className="bg-[#2E7D6B] hover:bg-[#256658] disabled:opacity-60 text-white font-semibold px-4 min-h-[44px] rounded-xl">Approve & reimburse</button>
                  <button data-testid={`expense-waive-${e.request_id}`} disabled={busy === e.request_id} onClick={() => resolve(e.request_id, "waive")} className="border-2 border-[#E2D9CE] hover:border-slate-400 disabled:opacity-60 text-slate-700 font-semibold px-4 min-h-[44px] rounded-xl">Waive</button>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
